/** Unpaid orders still open for payment (deadline not passed, or receipt awaiting staff review). */
export function isActionablePendingPayment(order: {
  status: string;
  paymentDeadline?: string | null;
  latestReceiptStatus?: string | null;
}): boolean {
  if (order.status !== "PENDING_PAYMENT") return false;
  if (order.latestReceiptStatus === "PENDING") return true;
  if (!order.paymentDeadline) return true;
  return new Date(order.paymentDeadline).getTime() > Date.now();
}
